/* unplugin-vue-components disabled */import { render } from "./PoolTransferOwnership.vue?vue&type=template&id=61a75c7c"
import script from "./PoolTransferOwnership.vue?vue&type=script&lang=js"
export * from "./PoolTransferOwnership.vue?vue&type=script&lang=js"

import "./PoolTransferOwnership.vue?vue&type=style&index=0&id=61a75c7c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__